import styled from '@emotion/styled';
import { H2, H3 } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';
import { DESKTOP_MEMBER_IMAGE_SIZE, MOBILE_MEMBER_IMAGE_SIZE } from 'screens/DeveloperPage/consts';
import { SectionTitle, SubsectionWrapper } from 'screens/DeveloperPage/styled';


export const Header = styled(H2)`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin: ${theme.spacing(3)} 0;
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin: ${theme.spacing(2.5)} 0;
  `}
`;

export const MembersWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -${theme.spacing(2)};
  `}

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin: 0 -${theme.spacing(3)} ${theme.spacing(4)};
  `}
`;

export const MemberItem = styled.div<{ hasDescription: boolean; }>`
  text-align: center;

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin: 0 ${theme.spacing(1.5)} ${theme.spacing(5)};
  `}

  ${({ theme, hasDescription }) => theme.media.showAt({ from: 3 })`
    ${hasDescription ? `
      &:hover {
        .member-description {
          visibility: visible;
        }
      }
    ` : ''}
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin: 0 ${theme.spacing(1)};
    &:last-of-type {
      margin-right: ${theme.spacing(3)};
    }
  `}
`;

export const MemberDescription = styled.div<{ show: boolean; }>`
  ${({ theme }) => `
    background: ${colorToAlpha(theme.colors.neutrals.grey1, 0.95)};
    color: ${theme.colors.neutrals.white};
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    visibility: hidden;
    padding: ${theme.spacing(3)};
  `}

  ${({ theme, show }) => theme.media.showAt({ to: 2 })`
    visibility: ${show ? 'visible' : 'hidden'};
    padding: ${theme.spacing(1.5)} ${theme.spacing(2)};
  `}
`;

export const MemberImageWrapper = styled.div`
${({ theme }) => `
    border-radius: ${theme.borderRadius.small};
    overflow: hidden;
    position: relative;
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    height: ${DESKTOP_MEMBER_IMAGE_SIZE}px;
    width: ${DESKTOP_MEMBER_IMAGE_SIZE}px;
    display: flex;
    justify-content: center;

    svg {
      height: ${DESKTOP_MEMBER_IMAGE_SIZE}px;
      width: ${DESKTOP_MEMBER_IMAGE_SIZE}px;
    }
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    height: ${MOBILE_MEMBER_IMAGE_SIZE}px;
    width: ${MOBILE_MEMBER_IMAGE_SIZE}px;

    svg {
      height: ${MOBILE_MEMBER_IMAGE_SIZE}px;
      width: ${MOBILE_MEMBER_IMAGE_SIZE}px;
    }
  `}
`;

export const MoreAbout = styled.div`
  ${({ theme }) => `
    width: 216px;
    margin: ${theme.spacing(2)} auto 0;
  `}
`;

export const MemberName = styled(SectionTitle.withComponent('div'))`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    margin: ${theme.spacing(3)} 0 ${theme.spacing(0.5)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin: ${theme.spacing(1)} 0 0;
  `}
`;

export const Root = styled(SubsectionWrapper)`
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: ${theme.spacing(6)};
  `}
`;

export const ToggleVisibility = styled(H3)<{ isCollapsed: boolean; }>`
  ${({ theme, isCollapsed }) => `
    color: ${theme.colors.neutrals.grey2}
    line-height: 20px;
    margin-bottom: ${theme.spacing(8)};
    margin-top: ${theme.spacing(2)};
    cursor: pointer;
    ${!isCollapsed && 'text-decoration-line: underline'};
  `}
`;
